import styled from "styled-components";
import { colors } from "@sonder/ui/source/styled/theme";

interface CancelButtonProps {
  fill?: string;
  fillHovered?: string;
  stroke?: string;
}

export const CancelButton = styled.span<CancelButtonProps>`
  cursor: pointer;
  display: flex;

  > svg {
    height: 1rem;
    width: 1rem;

    .outline {
      fill: ${props => props.fill || colors.gray6};
      stroke: ${props => props.stroke || colors.white};
    }

    .content {
      stroke: ${props => props.stroke || colors.white};
    }
  }

  &:hover {
    > svg {
      .outline {
        fill: ${props => props.fillHovered || props.fill || colors.gray4};
      }
    }
  }
`;
